import { useState, useEffect } from "react";
import api from "../../services/api";
import { toast } from "react-toastify";
import useWrapper from "../../hooks/useWrapper";
import { Currency, InputText } from "../Input";
import Button from "../Button";
import DatePicker from "../DatePicker";
import ModalCustom from "./modal-template-default";
import Required from "../Required";
import { validateForm } from "../ValidateForm";
import usePermission from "../../hooks/usePermission";

/**
 * Edição pontual de uma parcela (bills to pay): valor, vencimento e
 * comentário. Ao salvar o valor, o backend recalcula o value_total da
 * negociação-pai automaticamente.
 */
const ModalBillToPayInstallment = props => {
  const { show, onHide, bill, refreshCallback } = props;
  const { config } = useWrapper();
  const canUpdate = usePermission("financialCompany", "update");

  const [value, setValue] = useState();
  const [dueDate, setDueDate] = useState();
  const [description, setDescription] = useState("");
  const [isWaitingResponse, setisWaitingResponse] = useState(false);

  useEffect(() => {
    if (show) {
      setValue(bill?.value);
      setDueDate(bill?.due_date ? new Date(bill.due_date) : null);
      setDescription(bill?.description || "");
    }
  }, [show, bill]);

  const closeModal = () => {
    if (isWaitingResponse) return;
    onHide();
  };

  const saveInstallment = async () => {
    if (!canUpdate) return;
    const _is_valid = validateForm(document.getElementById("bill_to_pay_installment_container"));
    if (!_is_valid) return;
    setisWaitingResponse(true);
    try {
      await api.put(
        `bills-to-pay/${bill.id}`,
        {
          value: value || 0,
          due_date: dueDate,
          description,
        },
        config,
      );
      toast.success("Parcela atualizada!");
      refreshCallback && refreshCallback();
      onHide();
    } catch (__err) {
      const _message = __err?.response?.data?.error?.message;
      toast.error(_message || "Problemas ao atualizar a parcela!");
      console.error("__err", __err);
    } finally {
      setisWaitingResponse(false);
    }
  };

  return (
    <ModalCustom
      show={show}
      onHide={closeModal}
      id="bill_to_pay_installment_container"
      disableClose={isWaitingResponse}
    >
      <ModalCustom.Header>
        <ModalCustom.Title>Editar Parcela</ModalCustom.Title>
      </ModalCustom.Header>
      <ModalCustom.Body>
        <p className="small-label">
          Ao editar o valor desta parcela, o Valor Total do título de pagamento é recalculado automaticamente.
        </p>
        <div className="mt-2">
          <label>
            Valor <Required />
          </label>
          <Currency
            required={true}
            disabled={isWaitingResponse}
            allowNegative={false}
            value={value}
            valueChange={__ev => setValue(__ev)}
          />
        </div>
        <div className="mt-2">
          <label>
            Vencimento <Required />
          </label>
          <DatePicker
            required={true}
            disabled={isWaitingResponse}
            selected={dueDate || ""}
            changeDate={__ev => {
              if (__ev) setDueDate(__ev);
            }}
          />
        </div>
        <div className="mt-2">
          <label>Comentário</label>
          <InputText
            disabled={isWaitingResponse}
            value={description}
            onChange={__ev => setDescription(__ev.target.value)}
          />
        </div>
      </ModalCustom.Body>
      <ModalCustom.Footer>
        <Button disabled={isWaitingResponse} color="primary_ghost" onClick={closeModal}>
          Cancelar
        </Button>
        <Button disabled={isWaitingResponse || !canUpdate} onClick={saveInstallment} loading={isWaitingResponse}>
          Salvar
        </Button>
      </ModalCustom.Footer>
    </ModalCustom>
  );
};

export default ModalBillToPayInstallment;
